import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Route, Switch } from "react-router-dom";
import { useAppUser } from "../../../../../contexts/user-context/UserContext";
import SubMenu from "../../../components/side-nav-bar/sub-menus";
import SubMenuArchivedWorkshops from "../../../components/side-nav-bar/sub-menus/containers/archived-workshops/containers/sub-menu/SubMenuArchivedWorkshops";
import ArchivedSubsections from "./sub-sections/ArchivedSubsections";
import ArchivedWorkshops from "./workshops/ArchivedWorkshops";

export enum DashboardArchevedWorkshopPages {
  WORKSHOPS = "/dashboard/archived",
  SECTIONS = "/dashboard/archived/sections",
}

const ArchivedLibrary = () => {
  const appUser = useAppUser();

  return (
    <div className="dashboard-library-wrapper">
      <SubMenu>
        <SubMenuArchivedWorkshops type="PRIVATE" />
      </SubMenu>
      <Container fluid className="course-wrapper pt-0">
        <Row>
          <Col md={12} lg={12} sm={12}>
            <Switch>
              <Route path={DashboardArchevedWorkshopPages.WORKSHOPS} exact>
                <ArchivedWorkshops />
              </Route>
              {appUser.userRole.isModerator && (
                <Route path={DashboardArchevedWorkshopPages.SECTIONS} exact>
                  <ArchivedSubsections />
                </Route>
              )}
            </Switch>
          </Col>
          <Col md={3} lg={2} style={{ borderLeft: "solid 1px #333" }}></Col>
        </Row>
      </Container>
    </div>
  );
};

export default ArchivedLibrary;
